import { SET_DADOS_CARTEIRA } from "../mutations.type";
import { FETCH_DADOS_CARTEIRA } from "../actions.type";
import ConsultaService from "../../services/ConsultaService";

const INITIAL_STATE = {
  licencaPesca: null
};

export const state = Object.assign({}, INITIAL_STATE);

export const getters = {
  licencaPesca: state => state.licencaPesca
};

export const actions = {
  [FETCH_DADOS_CARTEIRA]: ({ commit }, protocolo) => {
    ConsultaService.buscarDadosCarteira(protocolo).then(({ data }) => {
      commit(SET_DADOS_CARTEIRA, data);
    });
  }
};

export const mutations = {
  [SET_DADOS_CARTEIRA]: (state, licencaPesca) =>
    (state.licencaPesca = licencaPesca)
};

export default {
  state,
  getters,
  actions,
  mutations
};
